import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Getdata } from "../helpers/api.service";
import Breadcrums from "../Components/common/Breadcrums";
import dayjs from "dayjs";

const ExtracurricularDetails = () => {
  const params = useParams();
  const location = useLocation();
  const { title } = location.state || {};
  const [data, setData] = useState({});
  const [loaded, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);

  const fetchData = () => {
    Getdata(
      process.env.REACT_APP_URL +
      `/front/${title?.toLowerCase()}/show/${process.env.REACT_APP_SUBDOMAIN
      }${params.title}`
    )
      .then((res) => {
        console.log("News API response:", res);
        if (res?.data) {
          setData(res.data);
          if (res.data.image) {
            setSelectedImage(res.data.image);
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching news:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="px-4 sm:px-6 lg:px-8 mt-10">
      <div className="max-w-7xl mx-auto text-left">
        <Breadcrums
          pages={[
            {
              title: "Extracurricular",
              link: `extra-curricular/${title}`,
            },
            { title: title, link: `extra-curricular/${title}` },
            { title: params.title },
          ]}
        />

        <div className="py-4">
          {selectedImage && (
            <div className="mb-4 w-full h-[220px] sm:h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden rounded-lg">
              <img
                src={selectedImage}
                alt="Selected"
                className="w-full h-full object-cover"
              />
            </div>
          )}

          <div className="relative flex flex-col md:flex-row justify-between text-gray-800">
            <div className="flex-1">
              <h3 className="text-xl md:text-2xl font-semibold mb-2">{data.title}</h3>
              <h3 className="text-sm text-gray-400 font-normal mb-3">
                {dayjs(data.createdAt).format("DD MMM YYYY")}
              </h3>

              {/* Main content */}
              {data.detailed && (
                <p className="text-base sm:text-lg mb-4">{data.detailed}</p>
              )}

              {data.description && (
                <div
                  className="prose prose-sm sm:prose lg:prose-lg max-w-none"
                  dangerouslySetInnerHTML={{ __html: data.description }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default ExtracurricularDetails;
